'use strict';

var pwdRequestApp = angular.module('pwdRequestApp', [ 'ngRoute', 'pwdRequestCtrls' ]);

pwdRequestApp.config([ '$routeProvider', function($routeProvider) {
    $routeProvider.when('/pwdRequest', {
        templateUrl : 'partials/passwordRequestForm.html',
        controller : 'pwdRequestCtrl'
    }).when('/pwdRequestSuccess', {
        templateUrl : 'partials/passwordRequestSuccess.html',
        controller : 'pwdRequestSuccessCtrl'
    }).otherwise({
        redirectTo : '/pwdRequest'
    });
} ]);

////////////////////////////////////////////////////////////////////////////////
////////////////// Controllers
////////////////////////////////////////////////////////////////////////////////

var pwdRequestCtrls = angular.module('pwdRequestCtrls', [ 'pwdRequestSvcs' ]);

pwdRequestCtrls.controller('pwdRequestCtrl', [
        '$scope',
        '$rootScope',
        '$location',
        'pwdRequestSvc',
        function($scope, $rootScope, $location, pwdRequestSvc) {

            $scope.forgot = 'password'; // Default radio button selection

            // 1. Submit request using REST API
            // 2. In Success handler check if there are any validation errors. If errors then be on same page and display errors.
            //    If no errors then navigate to success page.
            // 3. In Error handler (timeout or server exception) display generic internal error message
            $scope.submitForm = function() {
                $scope.formSubmit = {};
                $scope.formSubmit.fail = false;
                function successHandler(validationErrors) {
                    $location.path("/pwdRequestSuccess") // navigate to success page
                }
                function errorHandler(validationErrors) {
                    if (validationErrors) {
                        $scope.formSubmit.fail = true;
                    }
                }
                if ($scope.forgot == 'password' && $scope.username) {
                    $rootScope.validationErrors = pwdRequestSvc.requestPasswordReset.submit("username=" + $scope.username,
                            successHandler);
                } else if ($scope.forgot == 'username' && $scope.email) {
                    $rootScope.validationErrors = pwdRequestSvc.requestUsername.submit("email=" + $scope.email, successHandler, errorHandler);
                }
            };
        } ]);

pwdRequestCtrls.controller('pwdRequestSuccessCtrl', [ '$scope', function($scope) {
} ]);

pwdRequestCtrls.controller('verifyUserPwAnswerCtrl', [ '$scope', 'pwdRequestSvc', function($scope, pwdRequestSvc) {
    $scope.question = pwdRequestSvc.getUserPwQuestion.query();
    $scope.question.$promise.then(function() {
        $scope.userAnswers = $scope.question;
    });

    $scope.submit = function() {
        $scope.formSubmit = {};
        function successHandler(validationErrors) {
            if (!validationErrors || !validationErrors.errors) {

            }
        }
        $scope.formSubmit.validationErrors = pwdRequestSvc.verifyUserPwAnswer.query($scope.userAnswers, successHandler);
    };
} ]);

////////////////////////////////////////////////////////////////////////////////
////////////////// Services
////////////////////////////////////////////////////////////////////////////////

var pwdRequestSvcs = angular.module('pwdRequestSvcs', [ 'ngResource' ]);

pwdRequestSvcs.factory('AppContextSvc', [ '$location', function($location) {
    var absUrl = $location.absUrl();
    var appContext = "/" + absUrl.substring(absUrl.search(/[^\/]\/[^\/]/) + 2).split("/")[0];
    return {
        appContext : appContext
    };
} ]);

pwdRequestSvcs.factory('pwdRequestSvc', [ '$resource', 'AppContextSvc', function($resource, AppContext) {
    var appContext = AppContext.appContext;
    var action = {
        submit : {
            method : 'POST',
            headers : {
                'Content-Type' : 'application/x-www-form-urlencoded'
            }
        }
    };
    return {
        requestPasswordReset : $resource(appContext + '/rest/users/requestPasswordReset', {}, action),
        requestUsername : $resource(appContext + '/rest/users/requestUsername', {}, action),
        getUserPwQuestion : $resource(appContext + '/rest/users/requestUserPwQuestion', {}, {
            query : {
                method : 'GET'
            }
        }),
        verifyUserPwAnswer : $resource(appContext + '/rest/users/verifyUserPwAnswer', {}, {
            query : {
                method : 'GET'
            }
        })
    }
} ]);
